import Vue from 'vue';
import { locale, defaultLocale } from './data/locale';

/**
 * Format Date instance to a string
 */
Vue.filter('sessionDate', function (date) {
    if (!date) return '';

    const lang = navigator.language || navigator.languages[0];

    return date.toLocaleString(lang, {
        year: 'numeric',
        day: 'numeric',
        month: 'short',
        hour: 'numeric',
        minute: 'numeric',
    });
});

/**
 * Translate value with the current locale
 */
Vue.filter('trans', function (obj) {
    if (!obj || typeof obj === 'string') {
        return obj;
    }

    const translation = obj[locale()];

    if (!translation || translation === '') {
        return obj[defaultLocale];
    }

    return translation;
});